module.exports = __webpack_public_path__ + "static/media/alerta-combustible-verde.f9b2e11b.svg";